import { Directive, Input, TemplateRef, ViewContainerRef, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { FeatureFlagService } from '../../core/services/core.feature-flags.service';

@Directive({
  selector: '[featureFlag]'
})
export class FeatureFlagDirective implements OnInit, OnChanges {
  @Input('featureFlag') featureKey: string;
  private hasView = false;

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private featureFlagService: FeatureFlagService
  ) { }

  ngOnInit() {
    this.update();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['featureKey']) {
      this.update();
    }
  }

  private update() {
    const isEnabled = this.featureFlagService.isFeatureEnabled(this.featureKey);
    if (isEnabled && !this.hasView) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.hasView = true;
    } else if (!isEnabled && this.hasView) {
      this.viewContainer.clear();
      this.hasView = false;
    }
  }
}
